import { createSlice } from '@reduxjs/toolkit';
import FILTER_CONSTANTS, { FILTER_VALUES } from '../../constants/FilterConstants';
import { DEFAULT_PAGE, DEFAULT_PER_PAGE } from '../../constants/pagination';

const SORT_DEFAULT_UNMAPPED = 'source:ASC';
const SORT_DEFAULT_MISSING = 'date:DESC';

const initialState = {
  unmappedDataFeed: {
    ...structuredClone(FILTER_CONSTANTS.FILTER_DATA.UNMAPPED_DATA_FEED.INITIAL_PARAMS),
    pageNumber: DEFAULT_PAGE,
    rowsPerPage: DEFAULT_PER_PAGE,
    sort: SORT_DEFAULT_UNMAPPED,
  },

  missingDataFeed: {
    ...structuredClone(FILTER_CONSTANTS.FILTER_DATA.MISSING_DATA_FEED.INITIAL_PARAMS),
    pageNumber: DEFAULT_PAGE,
    rowsPerPage: DEFAULT_PER_PAGE,
    sort: SORT_DEFAULT_MISSING,
  },
};

/**
 * Helper function to update common filter fields (pagination and sort)
 * @param {Object} stateSlice - The state slice to update (e.g., state.unmappedDataFeed)
 * @param {Object} payload - The action payload
 * @param {string} defaultSort - Default sort value
 */
const updateCommonFilterFields = (stateSlice, payload, defaultSort) => {
  stateSlice.pageNumber = payload?.pageNumber || DEFAULT_PAGE;
  stateSlice.rowsPerPage = payload?.rowsPerPage || DEFAULT_PER_PAGE;
  stateSlice.sort = payload?.sort || defaultSort;
};

/**
 * Helper function to update date range filter
 * @param {Object} stateSlice - The state slice to update
 * @param {Object} payload - The action payload
 */
const updateDateRangeFilter = (stateSlice, payload) => {
  stateSlice[FILTER_VALUES.DATE_RANGE_FILTER] = payload?.[FILTER_VALUES.DATE_RANGE_FILTER] || {
    from: '',
    to: '',
  };
};

export const exceptionReportingFilterSlice = createSlice({
  name: 'exceptionReportingFilter',
  initialState,
  reducers: {
    setUnmappedDataFeedFilters(state, action) {
      const { payload } = action;
      state.unmappedDataFeed[FILTER_VALUES.SOURCE] = payload?.[FILTER_VALUES.SOURCE] || [];
      updateDateRangeFilter(state.unmappedDataFeed, payload);
      updateCommonFilterFields(state.unmappedDataFeed, payload, SORT_DEFAULT_UNMAPPED);
    },

    setMissingDataFeedFilters(state, action) {
      const { payload } = action;
      state.missingDataFeed[FILTER_VALUES.SOURCE_NAME] = payload?.[FILTER_VALUES.SOURCE_NAME] || [];
      state.missingDataFeed[FILTER_VALUES.JOB_TYPE] = payload?.[FILTER_VALUES.JOB_TYPE] || [];
      updateDateRangeFilter(state.missingDataFeed, payload);
      updateCommonFilterFields(state.missingDataFeed, payload, SORT_DEFAULT_MISSING);
    },

    resetUnmappedDataFeedFilters(state) {
      state.unmappedDataFeed = {
        ...initialState.unmappedDataFeed,
        sort: state.unmappedDataFeed.sort,
      };
    },

    resetMissingDataFeedFilters(state) {
      state.missingDataFeed = {
        ...initialState.missingDataFeed,
        sort: state.missingDataFeed.sort,
      };
    },

    resetState(state) {
      Object.assign(state, initialState);
    },
  },
});

export default exceptionReportingFilterSlice;
